import { useState, useEffect } from "react";
import AuthManager from "../managers/AuthManager";

const ALLOWED_EMAILS = [
  "keenan@lblbaseball.com",
  "jackkelly12902@gmail.com",
];

export const useLongBallAccess = () => {
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = AuthManager.onAuthStateChanged((user) => {
      setHasAccess(!!user?.email && ALLOWED_EMAILS.includes(user.email));
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return { hasAccess, loading };
};
